import el from '@finn-no/create-element';
import AccessibilityHelper from '../lib/AccessibilityHelper.js';

export default {
    dependencies: ['$element', 'recentsearchesservice', 'trackingservice'],
    callable(ele, recentsearchesservice, trackingService) {
        const recentSearchesToShow = 5;
        const key = ele.getAttribute('data-search-key');

        ele.addEventListener('click', handleItemClick);

        update();

        function handleItemClick(evt) {
            const actionEle = evt.target.closest('[data-action]');

            if (!actionEle || !ele.contains(evt.target)) {
                if (evt.target.hasAttribute('data-recent-search')) {
                    trackingService.trackLaterObj({
                        analyticsName: 'search.repeat-recent-search.click',
                        ecType: 'SEARCH',
                        ecCategory: 'BrowsepageRecentSearchesClick',
                    });
                }
                return;
            }

            const action = actionEle.getAttribute('data-action');
            if (action === 'delete-all') {
                deleteAll();
            }
        }

        function deleteAll() {
            recentsearchesservice.clearRecentSearches(key);
            render(getSearchesEle([]));
            AccessibilityHelper.focusFirst(ele);
        }

        function update() {
            recentsearchesservice
                .getRecentSearches(key)
                .then(res => res.json())
                .then(getSearchesEle)
                .catch(getErrorEle)
                .then(render);
        }

        function render(searchesEle) {
            clearContents();
            ele.append(searchesEle);
        }

        function clearContents() {
            while (ele.firstChild) {
                ele.firstChild.remove();
            }
        }

        function getSearchesEle(recentSearches) {
            if (recentSearches.length === 0) {
                return el(
                    'p',
                    { tabindex: '-1' },
                    'Etter hvert som du gjør søk på FINN vil de dukke opp her.'
                );
            }

            const buttonWrapperEle = el(
                'p.rightify',
                null,
                el(
                    'button.b1.blank.pan',
                    { type: 'button', 'data-action': 'delete-all' },
                    'Tøm lista'
                )
            );

            return el(
                'div',
                null,
                el(
                    'ol',
                    null,
                    recentSearches.slice(0, recentSearchesToShow).map(search =>
                        el(
                            'li',
                            null,
                            el(
                                'a.truncate.blockify.pvs',
                                {
                                    href: search.url,
                                    'data-recent-search': '',
                                },
                                search.title
                            )
                        )
                    )
                ),
                key ? null : buttonWrapperEle
            );
        }

        function getErrorEle() {
            return el(
                'p',
                null,
                'For øyeblikket klarte vi ikke å hente dine siste søk.'
            );
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/recentSearches.js